const status = [
  "ALL",
  "PROGRESS",
  "DERIVERING",
  "PICKUP",
  "SUCCESS",
  "FAIL",
  "CANCELBYDRIVER",
  "CANCELBYADMIN",
  "FINDDRIVER",
];

export const statusByRouteName = {
  ProgressOrder: ["ALL", "FINDDRIVER", "CANCELBYADMIN", "CANCELBYDRIVER", "PROGRESS"],
  ShippingOrder: ["ALL", "PICKUP", "DERIVERING"],
  HistoryOrder: ["ALL", "SUCCESS"],
};

export default status;
